import { useEffect } from "react";
 
import Loader from "src/layouts/loader/Loader";
import { getAppHost } from "src/constants/constants";
import useChatbotTree from "src/views/chatbotBuilder/hooks/useChatbotTree";
import useConnectChannels from "src/views/connectChat/hooks/useConnectChannels";
import ChatBotTree from "src/views/chatbotBuilder/ChatBotTree";

const ChatBot=({handleNext})=>{

    const { treeData, isTreeLoading, getChatbotTreeByUser } = useChatbotTree();

    const { userdata, getUserListData, isLoading } = useConnectChannels();
  
    useEffect(() => {
      getChatbotTreeByUser();
    }, []);
    return <>{isTreeLoading ? <Loader /> : <ChatBotTree treeData={treeData} userdata={userdata} getUserListData={getUserListData} isLoading={isLoading} isAccountSetup={true} handleNext={handleNext} />}
    <react-counter
      id="react-counter"
      adminid={userdata?._id}
      name={userdata?.chatBotData?.chatbotName}
      user_image={userdata?.chatBotData?.chatbotImage}
      bot_id={userdata?.integrationKeys?.chatbot?.encryptedKey}
      app_host={getAppHost()}>
    </react-counter>
  </>
}

export default ChatBot;




 
